import React from 'react';

// styles
import './chartInfoButton.scss';

const ChartInfoButton = () => {
  const handleClick = (e) => {
    e.preventDefault();
    window.document.body.style.top = `-${window.scrollY}px`;
    window.document.body.classList.add('allQuestionPopup-open');

    const popup = document.querySelector('.allQuestionPopup');
    if (popup) {
      popup.style.display = 'block';
    }

    const backdrop = document.querySelector('.allQuestionPopup-backdrop');
    if (backdrop) {
      backdrop.style.display = 'block';
    }
  };

  return (
    <div className="chartInfoButton">
      <button onClick={handleClick}>i</button>
    </div>
  );
};

export default ChartInfoButton;
